export function getAnalyticsSessionId() {
  try {
    const existing = localStorage.getItem('analytics_session_id');
    if (existing) return existing;
    const generated = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem('analytics_session_id', generated);
    return generated;
  } catch (err) {
    return null;
  }
}

export async function trackEvent(payload = {}) {
  try {
    const session_id = getAnalyticsSessionId();
    const token = localStorage.getItem('token');
    await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/analytics/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify({
        page_url: payload.page_url || window.location.href,
        session_id,
        referrer: payload.referrer || document.referrer || null,
        ...payload
      })
    });
  } catch (err) {
    // fail silently
  }
}
